export class PermissionList {
    constructor() { }
    static makeChild = (name: string, value: string) => {
        return [
            { name: `${name} Create`, value: `${value}.create` },
            { name: `${name} Get`, value: `${value}.get` },
            { name: `${name} Remove`, value: `${value}.remove` },
        ];
    };
    static loadPermissions = (name: string, value: string): {
        name: string, value: string, create: string, createChecked: boolean, get: string, getChecked: boolean, remove: string, removeChecked: boolean
    } => {
        return {
            name,
            value,
            create: `${value}.create`,
            createChecked: false,
            get: `${value}.get`,
            getChecked: false,
            remove: `${value}.remove`,
            removeChecked: false,
        };
    };

    static RolePermissions = this.loadPermissions('Role', 'role');
    static ActivityPermissions = this.loadPermissions('Activity', 'activity');
    static ActivityTypePermissions = this.loadPermissions('Activity Type', 'activity-type');
    static ContactPermissions = this.loadPermissions('Contact', 'contact');
    static EstimatePermissions = this.loadPermissions('Estimate', 'estimate');
    static ExpansePermissions = this.loadPermissions('Expanse', 'expanse');
    static ExpanseTypePermissions = this.loadPermissions('Expanse Type', 'expanse-type');
    static FollowUpPermissions = this.loadPermissions('Follow Up', 'follow-up');
    static LeadPermissions = this.loadPermissions('Lead', 'lead');
    static PaymentPermissions = this.loadPermissions('Payment', 'payment');
    static ProductPermissions = this.loadPermissions('Product', 'product');
    static ProjectPermissions = this.loadPermissions('Project', 'project');
    static PurchasePermissions = this.loadPermissions('Purchase', 'purchase');
    static SalesPermissions = this.loadPermissions('Sales', 'sales');
    static TaskPermissions = this.loadPermissions('Task', 'task');
    static UserPermissions = this.loadPermissions('User', 'user');
    static DashboardPermissions = this.loadPermissions('Dashboard', 'dashboard');
    static ApprovePermissions = this.loadPermissions('Approve', 'approve');

    static allPermissions = [
        { ...this.RolePermissions },
        { ...this.ActivityPermissions },
        { ...this.ActivityTypePermissions },
        { ...this.ContactPermissions },
        { ...this.EstimatePermissions },
        { ...this.ExpansePermissions },
        { ...this.ExpanseTypePermissions },
        { ...this.FollowUpPermissions },
        { ...this.LeadPermissions },
        { ...this.PaymentPermissions },
        { ...this.ProductPermissions },
        { ...this.ProjectPermissions },
        { ...this.PurchasePermissions },
        { ...this.SalesPermissions },
        { ...this.TaskPermissions },
        { ...this.UserPermissions },
        { ...this.DashboardPermissions },
        // { ...this.ApprovePermissions },
    ]

    // BUILDER_SUPER_ADMIN
    static superAdminPermissions = [
        { ...this.RolePermissions },
        { ...this.ActivityPermissions },
        { ...this.ActivityTypePermissions },
        { ...this.ContactPermissions },
        { ...this.EstimatePermissions },
        { ...this.ExpansePermissions },
        { ...this.ExpanseTypePermissions },
        { ...this.FollowUpPermissions },
        { ...this.LeadPermissions },
        { ...this.PaymentPermissions },
        { ...this.ProductPermissions },
        { ...this.ProjectPermissions },
        { ...this.PurchasePermissions },
        { ...this.SalesPermissions },
        { ...this.TaskPermissions },
        { ...this.UserPermissions },
        { ...this.DashboardPermissions },
        { ...this.ApprovePermissions },
    ]

    // BUILDER_ADMIN`
    static adminPermissions = [
        { ...this.RolePermissions },
        { ...this.ActivityPermissions },
        { ...this.ActivityTypePermissions },
        { ...this.ContactPermissions },
        { ...this.EstimatePermissions },
        { ...this.ExpansePermissions },
        { ...this.ExpanseTypePermissions },
        { ...this.FollowUpPermissions },
        { ...this.LeadPermissions },
        { ...this.PaymentPermissions },
        { ...this.ProductPermissions },
        { ...this.ProjectPermissions },
        { ...this.PurchasePermissions },
        { ...this.SalesPermissions },
        { ...this.TaskPermissions },
        { ...this.UserPermissions },
        { ...this.DashboardPermissions },
    ]

    // BUILDER_EMPLOYEE
    static employeePermissions = [
        { ...this.RolePermissions },
        { ...this.ActivityPermissions },
        { ...this.ActivityTypePermissions },
        { ...this.ContactPermissions },
        { ...this.EstimatePermissions },
        { ...this.ExpansePermissions },
        { ...this.ExpanseTypePermissions },
        { ...this.FollowUpPermissions },
        { ...this.LeadPermissions },
        { ...this.PaymentPermissions },
        { ...this.ProductPermissions },
        { ...this.ProjectPermissions },
        { ...this.PurchasePermissions },
        { ...this.SalesPermissions },
        { ...this.TaskPermissions },
        { ...this.UserPermissions },
        { ...this.DashboardPermissions },
    ]
}